import { css } from '@emotion/react'
import styled from '@emotion/styled'

type OrderNumProps = {
	orderNo: string
	tossCode: string
}

const OrderNum = ({ orderNo, tossCode }: OrderNumProps) => {
	return (
		<Block>
			<OrderNo>{orderNo}</OrderNo>
			<TossCode>{tossCode}</TossCode>
		</Block>
	)
}

const Block = styled.div`
	display: flex;
	flex-direction: column;
	word-break: break-all;
	padding: 0 2rem;
`

const textStyle = css`
	text-decoration: underline;
	text-underline-position: under;
`

const OrderNo = styled.span`
	${textStyle}
	margin-bottom: 0.3rem;
`

const TossCode = styled.span`
	${textStyle}
	color: #246CFF;
`

export default OrderNum
